export default __webpack_public_path__ + "static/musk-rush-solar-bg-80d8709e03e119d828d5d7cf45b75463.jpg";